const React = require("react");
const { usePrintify } = require("../context/PrintifyContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingImportedProducts = () => { const { t } = usePrintify(); return h(ProductCollectionPage, { imported: true, title: t("h_printify_imported_products", "Imported Printify products"), description: t("h_printify_imported_products_desc", "Products already linked to your Elakay shop.") }); };
module.exports = { DropshippingImportedProducts };
